import { Offcanvas } from "bootstrap"

export const codeBrickSelects = () => {
    const codeBricks = $('.code-brick')

    codeBricks.each((_, codeBrick) => {
        const selects = []
        const codeBrickSelects = $(codeBrick).find('.code-brick--select')
        const codeBrickDrawers = $(codeBrick).find('.code-brick--drawer')
        const codeBrickDrawerBackdrop = $(codeBrick).find('.code-brick--drawer-backdrop')

        codeBrickDrawerBackdrop.on('click', () => {
            codeBrickDrawers.each((_, drawer) => {
                const drawerInstance = Offcanvas.getOrCreateInstance(drawer)
                drawerInstance.hide()
            })
        })

        codeBrickDrawers.each((_, drawer) => {
            drawer.addEventListener('hidden.bs.offcanvas', function () {
                $(codeBrick).removeClass('drawer-open')
                $(codeBrick).removeAttr('style')
                $(drawer).removeAttr('style')
                selects.forEach(select => {
                    select.val(null).trigger('change')
                })
            })

            drawer.addEventListener('shown.bs.offcanvas', function () {
                const drawerHeight = $(drawer).outerHeight(true)
                const codeBrickHeight = $(codeBrick).outerHeight(true)
                if (drawerHeight > codeBrickHeight) {
                    $(codeBrick).css('height', `${drawerHeight}px`)
                } else {
                    $(drawer).css('height', `${codeBrickHeight}px`)
                }
            })
        })

        codeBrickSelects.each((_, select) => {
            const $select = $(select).select2({
                minimumResultsForSearch: -1,
                dropdownParent: $(select).parent()
            })

            $select.on('select2:select', (event) => {
                const { id } = event.params.data
                const drawer = codeBrickDrawers.filter(`#drawer-${id}`)
                if (drawer.length) {
                    const drawerInstance = Offcanvas.getOrCreateInstance(drawer.first()[0])
                    drawerInstance.show()
                    $(codeBrick).addClass('drawer-open')
                }
            })

            selects.push($select)
        })
    })
}